//const API_BASE = 'http://localhost/calcblog/api';
//const API_BASE = 'https://calcblog.free.nf/api'; // Points to your PHP API
//const API_BASE = 'https://calcblog.buzz/api'; // Points to your PHP API
//const API_BASE = '/api'; // Points to your PHP API
//const JSON_BASE = 'http://localhost:3000/data';  
const JSON_BASE = 'https://calcblog.buzz/data';  

export const apiService = {
  // Articles
  getArticles: async () => {
    //const response = await fetch(`${API_BASE}/articles/get-all.php`);
    const response = await fetch(`${JSON_BASE}/articles_data.json`);
    //const response = await fetch('/data/articles_data.json')
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
//    console.log("✅ Articles:", data);
    return await data;
  },

  getArticle: async (slug) => {
    /*
    const response = await fetch(`${API_BASE}/articles/get-by-slug.php?slug=${slug}`);
    return await response.json();
    */
   const response = await fetch(`${JSON_BASE}/articles_data.json`);
    //const response = await fetch('/data/articles_data.json')
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const json = await response.json();
    // articles are inside json.data
    const articles = json.data;
    const article = articles.find(article => article.slug === slug);

  //  console.log("✅ Articles for slug:", article);
    if (!article) {
      return { success: false, data: null };
    }

    return { success: true, data: article };

  },
  
  // Calculators
  getCalculators: async () => {
   /* const response = await fetch(`${API_BASE}/calculators/get-all.php`);
    return await response.json();
    */
    const response = await fetch(`${JSON_BASE}/calculators_data.json`);
    //const response = await fetch('/data/calculators_data.json')
    if (!response.ok)  {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return await data;
  },


  getCalculator: async (slug) => {
    /*const response = await fetch(`${API_BASE}/calculators/get-by-slug.php?slug=${slug}`);
    return await response.json();
    */
     const response = await fetch(`${JSON_BASE}/calculators_data.json`);
    //const response = await fetch('/data/calculators_data.json')
    if (!response.ok)  {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const json = await response.json();
    
    const calculators = json.data;
    const calculator = calculators.find(calculators => calculators.slug === slug);

  //  console.log("✅ Calculators for slug:", calculator);
    if (!calculators) {
      return { success: false, data: null };
    }

    return { success: true, data: calculator };
  }
};